// src/admin/components/kits/KitsTable.jsx
import React from 'react';
import PropTypes from 'prop-types';
import DataTable from '../common/DataTable';

export default function KitsTable({ items, onEdit, onDelete }) {
  const columns = [
    {
      key: 'name',
      label: 'Kit Name',
      sortable: true,
      icon: 'bi-box-seam',
      render: (row) => (
        <span className="fw-semibold">
          {row.name}
        </span>
      ),
    },
    {
      key: 'sku',
      label: 'SKU',
      sortable: true,
      render: (row) => row.sku,
    },
    {
      key: 'revision',
      label: 'Revision',
      sortable: true,
      render: (row) => row.revision || <span className="text-muted">—</span>,
    },
    {
      key: 'description',
      label: 'Description',
      sortable: false,
      render: (row) => row.description || <span className="text-muted">—</span>,
      filterValue: (row) => row.description || '',
    },
  ];

  const actions = [
    {
      key: 'edit',
      label: 'Edit kit',
      icon: 'bi-pencil',
      onClick: onEdit,
    },
    {
      key: 'delete',
      label: 'Delete kit',
      icon: 'bi-trash',
      tone: 'danger',
      onClick: onDelete,
    },
  ];

  return (
    <DataTable
      items={items}
      columns={columns}
      actions={actions}
      filterPlaceholder="Search kits…"
      emptyMessage="No kits have been created yet."
    />
  );
}

KitsTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

